import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ReactSVG from 'react-svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { withStyles } from '@material-ui/core/styles';
import {
  TableApp,
  TableAppHead,
  TableAppBody,
  TableAppRow,
  TableAppCell,
} from 'components/IterioApp/components/TableApp';

import CopiedIcon from 'images/icon-copied.svg';

const styles = {
  stickyTh: {
    background: '#E8E8EF',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
};

const CellLink = styled.a`
  color: inherit;
  font-size: inherit;
  text-decoration: underline;
  transition: 0.25s all;

  &:hover {
    color: #00bbf4;
  }
`;

const CopyButton = styled.button`
  padding: 0;
  border: 0;
  outline: 0;
  opacity: 0;

  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.25s all;

  &:hover svg g {
    fill: #00bbf4;
  }

  svg {
    transition: 0.25s all;
    width: 23px;

    g {
      transition: 0.25s all;
    }
  }
`;

const LinkCell = styled.div`
  position: relative;
  padding: 0 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  word-break: break-all;

  &:hover ${CopyButton} {
    opacity: 1;
  }
`;

const CopiedMsg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background: #fff;

  font-size: 18px;
  font-weight: 600;
  transition: 0.25s all;
  opacity: 0;

  &.is_active {
    z-index: 1;
    opacity: 1;
  }
`;

const getWidth = (width) => width || 200;

const getCellValue = (event, name, type, showCopiedInfo) => {
  const value = event[name];

  switch (type) {
    case 'time': return moment.utc(value).format('YYYY-MM-DD HH:mm:ss');
    case 'url': return formatLink(value, showCopiedInfo);
    default: return value;
  }
};

const formatLink = (value, showCopiedInfo) => {
  if (!value) return <LinkCell />;
  const href = isProperLink(value) ? value : addProtocolToUrl(value);

  return (
    <LinkCell>
      <CellLink href={href} target="_blank">{value}</CellLink>

      <CopyToClipboard
        text={value}
        onCopy={showCopiedInfo}
      >
        <CopyButton>
          <ReactSVG path={CopiedIcon} />
        </CopyButton>
      </CopyToClipboard>

      <CopiedMsg>
        Copied
      </CopiedMsg>
    </LinkCell>
  );
};

const isProperLink = (url) => {
  return url.includes('http:') || url.includes('https:');
};

const addProtocolToUrl = (url) => {
  return `http://${url}`;
};

const getHeaderNames = (label, name) => {
  const defaultName = name.split('_').join(' ');
  return label || defaultName;
};

const EventsTable = ({
  eventsData,
  eventsSort,
  sortTable,
  classes,
  viewConfig,
  handleOpenSnackbar,
}) => {
  if (!eventsData || !eventsData.length) return null;
  if (!viewConfig || !viewConfig.length) return null;
  eventsSort = eventsSort || {};

  const showCopiedInfo = (text, result) => {
    if (result) handleOpenSnackbar();
  };

  return (
    <TableApp fixed>
      <TableAppHead>
        <TableAppRow type="headerRow">
          {viewConfig.map(item => (
            <TableAppCell
              key={item.name}
              type="th"
              className={`${classes.stickyTh} positionSticky`}
              style={{ width: getWidth(item.width) }}
              sort={eventsSort.field === item.name}
              order={eventsSort.order}
              data-is-sortable={eventsSort.field === item.name}
              data-sort-field={item.name}
              onClick={sortTable}
            >
              {getHeaderNames(item.label, item.name)}
            </TableAppCell>
          ))}
        </TableAppRow>
      </TableAppHead>

      <TableAppBody>
        {eventsData.map((event, key) => (
          <TableAppRow key={key}>
            {viewConfig.map(item => (
              <TableAppCell key={item.name}>
                {getCellValue(event, item.name, item.type, showCopiedInfo)}
              </TableAppCell>
            ))}
          </TableAppRow>
        ))}
      </TableAppBody>
    </TableApp>
  );
};

export default withStyles(styles)(EventsTable);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/EventsTable/EventsTable.jsx